import { getConditionalObject } from 'utils/data';

const getBorder = ({ palette }) => `1px solid ${palette.border.default}`;
const getBorderImportant = ({ palette }) => `1px solid ${palette.border.default} !important`;

const sharedTypographyStyles = {
  fontSize: '1.6rem',
  fontWeight: 400,
  lineHeight: '2.4rem',
  color: ({ palette }) => palette.text.secondary,
};

export const declarationsPageStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '50px',

  '& .additional-title': {
    ...sharedTypographyStyles,

    '&.mb-10': {
      marginBottom: '10px',
    },
  },
};

export const sectionTitleStyles = {
  ...sharedTypographyStyles,
  fontSize: '1.4rem',
  fontWeight: 500,
  marginBottom: '12px',
};

export const sectionStyles = {
  padding: '24px',
  gap: '15px',
  border: getBorder,
  borderRadius: '5px',
};

export const textFieldStyles = {
  '& .label': {
    whiteSpace: 'unset',
    ...sharedTypographyStyles,
  },
};

export const getTextFieldStyles = ({ withHelperText = false } = {}) => ({
  ...textFieldStyles,

  ...getConditionalObject(!withHelperText, {
    '& .helper-text': {
      display: 'none',
    },
  }),
});

export const getCheckboxStyles = ({
  withHelperText = false,
  withRequiredIcon = false,
  withBottomBorder = false,
  withMarginLeft = false,
  customStyles,
} = {}) => ({
  ...getConditionalObject(withMarginLeft, {
    marginLeft: '10px',
  }),

  '& .checkbox-label': {
    ...sharedTypographyStyles,
  },

  '& .helper-text': {
    padding: '0px',
  },

  ...getConditionalObject(!withHelperText, {
    '& .helper-text': {
      display: 'none',
    },
  }),

  ...getConditionalObject(!withRequiredIcon, {
    '& .MuiFormControlLabel-asterisk': {
      display: 'none',
    },
  }),

  ...getConditionalObject(withBottomBorder, {
    borderBottom: getBorderImportant,
    paddingBottom: '8px !important',
  }),

  ...customStyles,
});

export const radioListStyles = {
  alignItems: 'start',
  justifyContent: 'space-between',
  borderBottom: getBorder,
  paddingBottom: '8px !important',

  '& .helper-text': {
    padding: 0,
  },

  ...textFieldStyles,

  '.label': {
    margin: 0,
    ...sharedTypographyStyles,
  },

  '.radio-button-label': {
    ...sharedTypographyStyles,
    color: ({ palette }) => palette.text.primary,
  },

  '& .radio-button-icon': {
    '& .MuiSvgIcon-root': {
      width: '21px',
      height: '21px',
    },
  },
};

export const getVerticalRadioListStyles = ({
  withBorderBottom = false,
  withHelperText = false,
} = {}) => ({
  ...radioListStyles,

  '& .form-control-label .radio-button-label': {
    color: ({ palette }) => palette.text.secondary,
  },

  ...getConditionalObject(!withBorderBottom, {
    borderBottom: 'unset',
  }),

  ...getConditionalObject(!withHelperText, {
    '& .helper-text': {
      display: 'none',
    },
  }),
});

export const getCheckboxesGroupStyles = ({
  padding = 0,
  checkboxesPadding = 0,
  withBottomBorder = false,
}) => ({
  flexDirection: 'column',
  padding,

  ...textFieldStyles,
  ...getCheckboxStyles({ withHelperText: true }),

  '& .helper-text': {
    paddingTop: '5px',
  },

  '& .checkboxes-group': {
    padding: checkboxesPadding,
  },

  ...getConditionalObject(withBottomBorder, {
    borderBottom: getBorder,
    paddingBottom: '8px !important',
  }),
});

export const getAdditionalContentStyles = withBottomBorder => ({
  padding: '8px 0 0 16px',

  ...getConditionalObject(withBottomBorder, {
    paddingBottom: '16px',
    borderBottom: getBorder,
  }),
});

export const additionalContentInputStyles = {
  '& .label': {
    ...sharedTypographyStyles,
  },
};

export const counselingFormStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};
